// tslint:disable: max-line-length

import { css, keyframes } from 'emotion';
import * as React from 'react';

const blink = keyframes`
  0% { opacity: 1; transform: scale(1) }
  50% { opacity: .1; transform: scale(.9) }
  100% { opacity: 1; transform: scale(1) }
`;

const main = (top: boolean) => css`
  position: absolute;
  left: -30px;
  transform: ${top ? 'rotate(-180deg)' : ''};

  #star1 {
    animation: ${blink} 3.4s ease infinite;
  }
  #star2 {
    animation: ${blink} 4.8s ease infinite;
  }
  #star3 {
    animation: ${blink} 3.6s ease infinite;
  }

  ${!top &&
    css`
      left: auto;
      bottom: -12px;
    `}
`;

export class Stars extends React.Component<{ isTop?: boolean }> {
  public render() {
    const { isTop = false } = this.props;

    return (
      <svg
        width="29px"
        height="32px"
        viewBox="0 0 29 32"
        version="1.1"
        xmlns="https://www.w3.org/2000/svg"
        className={main(isTop)}
      >
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="stars" fill="#72659F">
            <path
              d="M9.49,22.614 C10.98,24.039 14,24.862 14,24.862 C14,24.862 10.95,26.034 9.457,27.506 C7.96,28.98 7.137,32 7.137,32 C7.137,32 6.039,28.98 4.424,27.288 C2.802,25.6 0,24.862 0,24.862 C0,24.862 3.02,24.039 4.537,22.5 C6.049,20.958 7.137,18 7.137,18 C7.137,18 8,21.188 9.49,22.614"
              id="star1"
            />
            <path
              d="M15.779,3.295 C16.843,4.314 19,4.902 19,4.902 C19,4.902 16.821,5.739 15.755,6.79 C14.686,7.843 14.098,10 14.098,10 C14.098,10 13.314,7.843 12.16,6.635 C11.002,5.428 9,4.902 9,4.902 C9,4.902 11.157,4.314 12.24,3.215 C13.32,2.113 14.099,0 14.099,0 C14.099,0 14.716,2.277 15.779,3.295"
              id="star2"
            />
            <path
              d="M26.423,16.636 C27.274,17.451 29,17.921 29,17.921 C29,17.921 27.257,18.591 26.404,19.431 C25.549,20.274 25.079,22 25.079,22 C25.079,22 24.451,20.274 23.528,19.308 C22.601,18.343 21,17.92 21,17.92 C21,17.92 22.726,17.45 23.593,16.57 C24.456,15.69 25.079,13.999 25.079,13.999 C25.079,13.999 25.572,15.821 26.423,16.635"
              id="star3"
            />
          </g>
        </g>
      </svg>
    );
  }
}
